import { MULTI_CARRIER_ENABLED } from 'core/constants/environment'
import addFirstCignaRef from 'sites/enroll.pivothealth.com/welcome-back-quote/addFirstCignaRef'
import updateAddons from 'sites/pivothealth.com/fixed-benefit-medical/consumer/quotes/utils/updateAddons'
import forEach from 'utils/DOM/forEach'
import getById from 'utils/DOM/getById'
import getURLParams from 'utils/DOM/getURLParams'
import textContent from 'utils/DOM/textContent'
import toggleClass from 'utils/DOM/toggleClass'
import renderFilters from './renderFilters'
import renderPlanFilters from './renderPlanFilters'
import getTemplate from './utils/getTemplate'
import { renderMultiCarrierPlans, renderPlans } from './utils/renderPlans'
import renderRecommended from './utils/renderRecommended'
import renderRecommendedLink from './utils/renderRecommendedLink'
import getMultiCarrierCoverageDetails from 'utils/pivot/multicarrier/get-multicarrier-coverage-details'

const templatePlan = getTemplate('template-plan')
const templateMultiCarrierPlan = getTemplate('template-multi-carrier-plan')
const plansWrap = getById('plans-wrap')
const tileWrap = getById('tiles-wrap')
const tiles = getById('tiles')

function updateDOM(state) {
  if (state.plansSTM.length === 0) {
    return undefined
  }

  const urlParams = getURLParams()
  const isMultiCarrier = urlParams.months !== '4' && urlParams.months

  if (!isMultiCarrier) {
    // Filter Section
    let hiddenFilters
    if (state.hcStorage.location.state_acronym === 'ND') {
      hiddenFilters = { period: [360] }
    }

    renderFilters(
      state.filterOptions,
      state.filters,
      state.defaultPeriod,
      state,
      hiddenFilters
    )
  }

  toggleClass(document.body, 'noMatch', state.plansToShow.length === 0)

  const plans = Object.entries(state.plans).map(entry => entry[1])
  const multiCarrierPlans = plans.filter((plan: Plan) => plan?.multiCarrierPlan)
  // If no multi-carrier plans are present in the quote response:
  if (multiCarrierPlans.length === 0 && MULTI_CARRIER_ENABLED) {
    // Change the text of the "Short Term - Up to 4 Months" nav to just be "Short Term"
    textContent('#toolbar-stm-4', 'Short Term')
    // Hide the multi-carrier tab
    toggleClass('#toolbar-stm-multi', 'd-none', true)
    // Redirect to the single-carrier tab
    const link = getById('toolbar-stm-4') as HTMLLinkElement
    link && document.location.assign(link.href)
  }

  if (state.plansToShow.length > 0) {
    if (!isMultiCarrier || !MULTI_CARRIER_ENABLED) {
      renderPlans(plansWrap, templatePlan, state, state.plansToShow)

      renderPlanFilters(
        state.plansToShow,
        state.plans,
        state.filterOptionsByProductType,
        state.filtersByProductType,
        state
      )

      const showRecommended = state.recommended.length > 0
      if (showRecommended) {
        renderRecommended(tileWrap, state.templateTile, state, state.recommended, true)

        if (state.recommendDurations) {
          renderRecommendedLink(state.recommendDurations)
        }
      } else {
        tileWrap.innerHTML = ''
      }

      toggleClass(tiles, 'd-none', !showRecommended)

      forEach('.js-option-card', node => {
        toggleClass(node, 'Card-active', state.filters.type.includes(node.dataset.id))
      })

      addFirstCignaRef()

      updateAddons(state)
    } else {
      const formattedPlans = {}
      multiCarrierPlans.forEach(plan => {
        formattedPlans[plan.planId] = plan
      })

      renderMultiCarrierPlans(
        plansWrap,
        templateMultiCarrierPlan,
        state,
        multiCarrierPlans
      )

      const plansToShow = multiCarrierPlans.map(plan => plan.planId)
      const { completeLabel, available } = getMultiCarrierCoverageDetails(state)
      toggleClass('.advise', 'd-none', !available)
      textContent('.complete-lable-coverage', completeLabel)

      renderPlanFilters(
        plansToShow,
        formattedPlans,
        state.filterOptionsByProductType,
        state.filtersByProductType,
        state,
        true
      )
    }
  }
}

export default updateDOM
